(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-certification-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const SELECTORS = {
      form: '[data-pcd-form]',
      addToCartBtn: '[data-pcd-add-to-cart]',
      navLink: '.pcd-nav__link'
    };

    const CLASSES = {
      loading: 'pcd-btn--loading'
    };

    const LOADING_TIMEOUT = 3000;
    const SCROLL_OFFSET = 100;

    /**
     * Initialize product forms with loading state
     */
    const initForms = () => {
      document.querySelectorAll(SELECTORS.form).forEach(form => {
        form.addEventListener('submit', handleFormSubmit);
      });
    };

    /**
     * Handle form submission
     * @param {Event} event
     */
    const handleFormSubmit = (event) => {
      const form = event.currentTarget;
      const button = form.querySelector(SELECTORS.addToCartBtn);

      if (!button || button.disabled) return;

      button.classList.add(CLASSES.loading);
      button.setAttribute('aria-busy', 'true');

      // Remove loading state after timeout (fallback for navigation)
      setTimeout(() => {
        button.classList.remove(CLASSES.loading);
        button.removeAttribute('aria-busy');
      }, LOADING_TIMEOUT);
    };

    /**
     * Initialize smooth scroll for anchor links
     */
    const initSmoothScroll = () => {
      document.querySelectorAll(SELECTORS.navLink).forEach(link => {
        link.addEventListener('click', handleAnchorClick);
      });
    };

    /**
     * Handle anchor link click
     * @param {Event} event
     */
    const handleAnchorClick = (event) => {
      const href = event.currentTarget.getAttribute('href');

      if (!href?.startsWith('#')) return;

      const target = document.querySelector(href);

      if (!target) return;

      event.preventDefault();

      const offsetPosition = target.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      // Update URL without jumping
      history.pushState(null, '', href);

      // Set focus for accessibility
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    };

    /**
     * Initialize all functionality
     */
    const init = () => {
      initForms();
      initSmoothScroll();
    };

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
